<template>
<div id="feedBack">
  <form id="form" @submit.prevent="submit" ref="form">
  <div class="feedbackContainer">
    <div class="titleContainer">
      {{$t('feedBack.maintitle')}}
    </div>
    <div class="firstTitle">
      {{$t('feedBack.firstTitle')}}
    </div>
    <div class="secondTitle">
      {{$t('feedBack.secoundTitle')}}
    </div>
    <div class="smileContainer" :class="[this.$lang === 'ar' ? 'd-rtl' : '']">
      <div class="iconContainer">
        <div class="Great icon" >
          <img src="../../assets/icons/GreatIcon.svg" class="FeedbackIcon" id="Great" @click="imojeType(0, 0)">
        </div>
        <div class="react" id="Greattitle" v-if="!great" >
          {{$t('feedBack.great')}}
        </div>
        <div class="react" v-if="great" style="font-weight: bold">
          {{$t('feedBack.great')}}
        </div>
      </div>
      <div class="iconContainer">
        <div class="Good icon" >
          <img src="../../assets/icons/GoodIcon.svg" class="FeedbackIcon" id="Good" @click="imojeType(1, 1)">
        </div>
        <div class="react" id="Goodtitle" v-if="!good">
          {{$t('feedBack.good')}}
        </div>
        <div class="react" v-if="good" style="font-weight: bold">
          {{$t('feedBack.good')}}
        </div>
      </div>
      <div class="iconContainer">
        <div class="Average icon">
          <img src="../../assets/icons/AverageIcon.svg" class="FeedbackIcon" id="Average"  @click="imojeType(2, 2)">
        </div>
        <div class="react" id="Averagetitle" v-if="!average">
          {{$t('feedBack.average')}}
        </div>
        <div class="react" v-if="average" style="font-weight: bold">
          {{$t('feedBack.average')}}
        </div>
      </div>
      <div class="iconContainer">
        <div class="Poor icon">
          <img src="../../assets/icons/PoorIcon.svg" class="FeedbackIcon" id="Poor"  @click="imojeType(3, 3)">
        </div>
        <div class="react" id="Poortitle" v-if="!poor">
          {{$t('feedBack.poor')}}
        </div>
        <div class="react" v-if="poor" style="font-weight: bold">
          {{$t('feedBack.poor')}}
        </div>
      </div>
      <div class="iconContainer">
        <div class="Worst icon">
          <img src="../../assets/icons/WorstIcon.svg" class="FeedbackIcon" id="Worst" @click="imojeType(4, 4)" >
        </div>
        <div class="react" id="Worsttitle" v-if="!worst">
          {{$t('feedBack.worst')}}
        </div>
        <div class="react" v-if="worst" style="font-weight: bold">
          {{$t('feedBack.worst')}}
        </div>
      </div>
    </div>
  </div>
  <div class="submitContainer ">
    <div class="background">
      <div class="titleContainer submittitle">
        {{$t('feedBack.maintitle2')}}
      </div>
      <div class="firstTitle">
        {{$t('feedBack.firstTitle2')}}
      </div>
      <div class="feedback hidden" id="hideFeed">
        <div class="position-relative">
        <img src="../../assets/icons/testcard.svg" class="feedbackForm" @load="loading">
        <img src="../../assets/icons/cardtest.svg" class="feedbackForm2" @load="loading">
        <img src="../../assets/icons/mobilecard.svg" class="feedbackForm3" @load="loading">
          <div class="inputsContainer" v-if="imageLoading">
            <div class="row rowContainer">
              <div class="col-6">
                <input type="text" :placeholder="namePlaceholder" class="inputField" id="fullName" v-model="fullName" @input="fullNameValidation" :style="lang === 'ar' ? 'font-family: Mtn-arabic-regular': '' ">
                <small class="errorFeedback col-6" v-if="submited"> {{nameError}} </small>
              </div>
              <div class="col-6">
                <input type="text" :placeholder="phonePlaceholder" class="inputField" id="mobailNumber" v-model="mobile" @input="mobileValidation" oninput="this.value = this.value.replace(/([^+0-9]+)/gi, '')" :style="lang === 'ar' ? 'font-family: Mtn-arabic-regular': '' ">
                <small class="errorFeedback col-6" v-if="submited"> {{mobileError}} </small>
              </div>
            </div>
            <div class="row rowContainer">
              <div class="col-6">
                <input type="text" :placeholder="emailPlaceholder" class="inputField" id="email" v-model="email" @input="emailValidation" :style="lang === 'ar' ? 'font-family: Mtn-arabic-regular': '' ">
                <small class="errorFeedback col-6" v-if="submited"> {{emailError}} </small>
              </div>
              <div class="col-6">
<!--                <input type="file" placeholder="Attach a file" class="inputField fileinput" title="">-->
                <div class="position-relative">
                  <span class="deleteFile" @click="deleteFile"  v-if="fileNotNull" :class="[this.$lang === 'ar' ? 'arPosition' : 'enPosition']"><img src="../../assets/icons/closeBtn.svg" height="100%" width="100%"></span>
                  <label for="files" class="inputField fileinput Filelabel" :style="lang === 'ar' ? 'font-family: Mtn-arabic-regular': '' " >{{fileLabel}}</label>
<!--                  <input id="files" style="visibility:hidden; position: absolute" type="file" @change="fileValidation">-->
                  <v-file-input id="files" style="visibility:hidden; position: absolute" type="file" @change="fileValidation" v-model="file" accept=".pdf" :style="lang === 'ar' ? 'font-family: Mtn-arabic-regular': '' "></v-file-input>
                  <small class="errorFeedback col-6" v-if="submited"> {{fileError}} </small>
                </div>
              </div>
            </div>
            <div class="row rowContainer">
              <div class="col-12">
                <input type="text" :placeholder="issuePlaceholder" class="inputFielddesc" id="message" v-model="message" @input="messageValidation" :style="lang === 'ar' ? 'font-family: Mtn-arabic-regular': '' ">
                <small class="errorFeedback col-6" v-if="submited"> {{messageError}} </small>
              </div>
            </div>
          </div>
          <button class="yellow-button flex-center" v-if="imageLoading" >
            <div class="white-blur"></div>
            <div v-if="isLoading" class="spinner-border text-light" role="status"></div>
            <img v-if="!isLoading" class="inner_arrow" src="../../assets/icons/buttonArrow.svg">
            <span v-if="!isLoading" class="read-more submit" :class="[this.$lang === 'ar' ? 'arBtn' : '']">{{$t('feedBack.submit')}}</span>
          </button>
      </div>
      </div>
    </div>
  </div>
  </form>
</div>
</template>

<script>
import $ from 'jquery'
import ms from '../../utils/messeging'
import FeedbackRepository from '../../repositories/FeedbackRepository'
export default {
  name: 'Feedback',
  data () {
    return {
      lang: this.$lang,
      FeedBackSubmit: new FeedbackRepository(),
      great: false,
      good: false,
      average: false,
      poor: false,
      worst: false,
      nameError: '',
      numError: '',
      fullName: '',
      mobile: '',
      mobileError: '',
      email: '',
      emailError: '',
      message: '',
      messageError: '',
      fileError: '',
      namePlaceholder: this.$t('feedBack.form.fullName'),
      emailPlaceholder: this.$t('feedBack.form.email'),
      phonePlaceholder: this.$t('feedBack.form.mobileNumber'),
      issuePlaceholder: this.$t('feedBack.form.issueDescription'),
      reactionType: '',
      emojiValue: '',
      file: [],
      isLoading: false,
      submited: false,
      fileLabel: this.$t('feedBack.form.attachFile'),
      fileNotNull: false,
      sendFile: false,
      imageLoading: false
    }
  },
  mounted () {
    this.selectedImoje()
    this.arabic()
    $(document).ready(function () {
      $('#hideFeed').removeClass('hidden')
    })
    window.addEventListener('resize', () => {
      this.formResponsive()
    })
  },
  methods: {
    loading () {
      this.imageLoading = true
    },
    imojeType (num, val) {
      // this.great = !this.great
      // this.good = !this.good
      // this.average = !this.average
      // this.worst = !this.worst
      // this.poor = !this.poor
      if (val === 0) {
        this.great = !this.great
        this.good = false
        this.average = false
        this.poor = false
        this.worst = false
      } else if (val === 1) {
        this.good = !this.good
        this.great = false
        this.average = false
        this.poor = false
        this.worst = false
      } else if (val === 2) {
        this.average = !this.average
        this.good = false
        this.great = false
        this.poor = false
        this.worst = false
      } else if (val === 3) {
        this.poor = !this.poor
        this.good = false
        this.average = false
        this.great = false
        this.worst = false
      } else if (val === 4) {
        this.worst = !this.worst
        this.good = false
        this.average = false
        this.poor = false
        this.great = false
      }
      if (this.great === true || this.good === true || this.average === true || this.worst === true || this.poor === true) {
        this.reactionType = num
      } else {
        this.reactionType = ''
      }
    },
    selectedImoje () {
      $('.FeedbackIcon').click(function () {
        $('.FeedbackIcon').not(this).removeClass('selected')
        $(this).toggleClass('selected')
      })
    },
    fullNameValidation () {
      const fullNameReg = /^[a-zA-Z\s]+$/
      if (this.fullName === '') {
        this.nameError = this.$t('feedBack.validation.required.fullName')
        return false
      } else if (fullNameReg.test(this.fullName) === false) {
        this.nameError = this.$t('feedBack.validation.invalid.fullName')
        return false
      } else {
        this.nameError = ''
        return true
      }
    },
    emailValidation () {
      const emailReg = /^\S+@\S+\.\S+$/
      if (this.email === '') {
        this.emailError = this.$t('feedBack.validation.required.email')
        return false
      } else if (emailReg.test(this.email) === false) {
        this.emailError = this.$t('feedBack.validation.invalid.email')
        return false
      } else {
        this.emailError = ''
        return true
      }
    },
    messageValidation () {
      if (this.message === '') {
        this.messageError = this.$t('feedBack.validation.required.issueDescription')
        return false
      } else {
        this.messageError = ''
        return true
      }
    },
    mobileValidation () {
      const mobileReg = /^[+]?[(]?[0-9]{3}[)]?[-\s]?[0-9]{3}[-\s]?[0-9]{4,6}$/im
      if (this.mobile === '') {
        this.mobileError = this.$t('feedBack.validation.required.mobileNumber')
        return false
      } else if (mobileReg.test(this.mobile) === false) {
        this.mobileError = this.$t('feedBack.validation.invalid.mobileNumber')
        return false
      } else {
        this.mobileError = ''
        return true
      }
    },
    fileValidation () {
      const fileInput =
          document.getElementById('files')
      const filePath = fileInput.value
      // Allowing file type
      const allowedExtensions =
          /(\.pdf)$/i
      this.sendFile = true
      if (fileInput.value === '') {
        this.sendFile = false
        return true
      } else if (!allowedExtensions.exec(filePath)) {
        this.fileError = 'Invalid file'
        this.fileError = this.$t('feedBack.validation.required.attachFile')
        this.fileLabel = this.$t('feedBack.form.attachFile')
        $('.fileinput').css('color', 'gray')
        return false
      } else {
        this.fileLabel = this.file.name
        this.fileNotNull = true
        this.sendFile = true
        $('.fileinput').css('color', '#1d1d1d')
        this.fileError = ''
        return true
      }
    },
    deleteFile () {
      this.fileNotNull = false
      const fileInput =
        document.getElementById('files')
      fileInput.value = ''
      this.sendFile = false
      this.file = []
      this.fileLabel = this.$t('feedBack.form.attachFile')
    },
    reactValidation () {
      if (this.reactionType !== '') {
        return true
      } else {
        return false
      }
    },
    async submit () {
      this.submited = true
      if (this.reactionType === '') {
        ms.errorMessage(this.$t('feedBack.validation.required.Evaluation'))
      }
      this.fullNameValidation()
      this.emailValidation()
      this.messageValidation()
      this.mobileValidation()
      this.fileValidation()
      this.reactValidation()
      if (this.fullNameValidation() && this.emailValidation() && this.messageValidation() && this.mobileValidation() && this.fileValidation() && this.reactValidation()) {
        this.isLoading = true
        $('.yellow-button').prop('disabled', true)

        try {
          const formData = new FormData()
          formData.append('name', this.fullName)
          formData.append('contactNumber', this.mobile)
          formData.append('email', this.email)
          if (this.sendFile === true) {
            formData.append('file_doc', this.file)
          }
          formData.append('message', this.message)
          formData.append('type', this.reactionType)
          const response = await this.FeedBackSubmit.post(formData)
          if (response.data.status === 200) {
            ms.successMessage(response.data.message)
            this.isLoading = false
            $('.yellow-button').prop('disabled', false)
            $('.FeedbackIcon').removeClass('selected')
            this.fullName = ''
            this.mobile = ''
            this.email = ''
            this.file = []
            this.deleteFile()
            this.message = ''
            this.reactionType = ''
          } else {
            ms.errorMessage(response.data.message)
            this.isLoading = false
            $('.yellow-button').prop('disabled', false)
          }
        } catch (e) {
          try {
            if (e.response.data) {
              ms.errorMessage(e.response.data.message)
              this.isLoading = false
              $('.yellow-button').prop('disabled', false)
            }
          } catch {
            ms.errorMessage('Sorry Something Went Wrong')
            this.isLoading = false
            $('.yellow-button').prop('disabled', false)
          }
        }
      }
    },
    arabic () {
      if (this.$lang === 'ar') {
        $('.titleContainer').css('font-family', 'Mtn-arabic-bold')
        $('.secondTitle').css('font-family', 'Mtn-arabic-bold')
        $('.firstTitle').css('font-family', 'Mtn-arabic-regular')
        $('.feedback, .inputsContainer').addClass('arabicStyle')
        // $('#feedBack .yellow-button .read-more').addClass('arabicButton')
        $('.inputField').css('font-family', 'Mtn-arabic-regular')
        $('.inputField').css('padding-left', '8vw')
        $('.inputFielddesc').css('font-family', 'Mtn-arabic-regular')
        $('.react').css('font-family', 'Mtn-arabic-regular')
        $('#mobailNumber').css('direction', 'ltr')
        $('#mobailNumber').css('text-align', 'right')
        // $('#feedBack .yellow-button .read-more').css('font-family', 'Mtn-arabic-regular')
        $('#feedBack .yellow-button .read-more').css('right', 'calc(50% - 11px)')
        $('.v-tabs').css('padding', '0 4vw 0 6vw')
        if (window.innerWidth < 1000) {
          $('.feedback').css('margin', '0 1vw 0 0')
        }
      } else {
        if (window.innerWidth < 1020) {
          $('.feedback').css('margin', '0 0 0 2.5vw')
        }
        $('.errorFeedback').addClass('arabicfont')
        $('.inputField').css('padding-right', '8vw')
      }
    },
    formResponsive () {
      if (this.$lang === 'ar') {
        if (window.innerWidth < 1000 && window.innerWidth > 760) {
          $('.inputsContainer').css('left', '85px')
        } else if (window.innerWidth < 760 && window.innerWidth > 570) {
          $('.inputsContainer').css('left', '65px')
        } else if (window.innerWidth < 570) {
          $('.inputsContainer').css('left', '55px')
        } else {
          $('.inputsContainer').css('left', '75px')
        }
      }
    }
  },
  watch: {
    reactionType (val) {
      this.reactionType = val
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";
.d-rtl {
  direction: rtl;
}
  .feedbackContainer{
    background-color: $--light-white;
    /*margin-top: 180px;*/
    padding: 20px 15px 2px 15px;
  }
  .titleContainer{
    color: $--yellow;
    font-size: 28px;
    padding: 10px 10px;
    font-family: Mtn-bold;
  }
  .submittitle{
    padding-top: 35px;
  }
  .firstTitle{
    font-family: Mtn-regular;
  }
  .secondTitle{
    font-size: 17px;
    font-family: Mtn-bold;
  }
  .arBtn{
    //transform: rotateY(180deg);
    font-family: Mtn-arabic-regular !important;
    /*right: calc(50% - 11px) !important;*/
  }
  .smileContainer{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .FeedbackIcon{
    height: 70px;
    width: 70px;
    opacity: 0.7;
    margin-bottom: 15px;
    border-radius: 50%;
    cursor: pointer;
    transition: all 200ms;
    box-shadow: 5px 16px 10px -4px rgba(0, 0, 0, 0.2) !important
  }
  .FeedbackIcon:hover{
    height: 80px;
    width: 80px;
    opacity: 1;
    box-shadow: 5px 16px 15px -4px rgba(0, 0, 0, 0.2) !important
  }
  .selectedTitle{
    font-weight: bold;
  }
  .selected{
    height: 80px;
    width: 80px;
    opacity: 1;
    box-shadow: 5px 16px 15px -4px rgba(0, 0, 0, 0.2) !important;
  }
  .iconContainer{
    padding: 2vh 5vw;
  }
  .icon{
    height: 90px;
    width: 90px;
  }
  .submitContainer{
    background-image: $--gray-gradient;
    min-height: 40rem
  }
  /*.background{*/
  /*  background-image: url("");*/
  /*}*/
  .feedback{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
.feedbackForm{
  width: 1300px;
  position: relative;
}
.yellow-button{
  right: 218px;
  bottom: 95px;
  box-shadow: 18px 23px 21px -21px rgba(0, 0, 0, 0.2);
  /*border: 2px white solid;*/
}
#feedBack .yellow-button .read-more {
  //right: calc(50% - 17.5px);
}
/*.arabicButton{*/
/*  transform: rotateY(180deg) !important;*/
/*  font-family: Mtn-arabic-regular !important;*/
/*  right: calc(50% - 11px) !important;*/
/*}*/
.inputsContainer{
  width: 87%;
  height: 50%;
  /*background-color: #4caf50;*/
  bottom: 190px;
  position: absolute;
  left: 75px
}
.rowContainer{
  padding: 5px 5px;
}
.inputField{
  width: 90%;
  border-bottom: 0.5px #1d1d1d solid;
  padding: 10px 7px;
  font-family: Mtn-regular;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.inputFielddesc{
  width: 95%;
  border-bottom: 0.5px #1d1d1d solid;
  padding: 10px 7px;
  font-family: Mtn-regular;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.feedbackForm2{
  display: none;
}
.feedbackForm3{
  display: none;
}
.background {
  background: url("../../assets/icons/test2.svg") left bottom no-repeat, url("../../assets/icons/test.svg") right top no-repeat;
  background-size: contain;
}
@media only screen and (max-width: 1000px) {
  .background {
    background: url("../../assets/icons/test.svg") right top no-repeat;
  }
}
 input:focus-visible{
   outline: none;
   border-bottom: 1.5px #1d1d1d solid;
}
 input::placeholder{
   color: #1D1D1D;
 }
 .Great,.Good,.Average,.Poor,.Worst{
   border-radius: 50%;
 }
 .Great:hover ~ .react{
   font-weight: bold;
 }
.Good:hover ~ .react{
  font-weight: bold;
}
.Average:hover ~ .react{
  font-weight: bold;
}
.Poor:hover ~ .react{
  font-weight: bold;
}
.Worst:hover ~ .react{
  font-weight: bold;
}
.errorFeedback{
  display: block;
  color: red;
  font-size: 10px;
  position: absolute;
  padding: 0 2vw;
  text-align: start;
  font-family: Mtn-arabic-regular;
}
.arabicfont{
  font-family: Mtn-regular !Important;
}
@media only screen and (max-width: 800px) {
  .FeedbackIcon{
    height: 60px;
    width: 60px;
  }
  .FeedbackIcon:hover{
    height: 70px;
    width: 70px;
  }
  .selected{
    height: 70px;
    width: 70px;
  }
  .iconContainer{
    padding: 2vh 4vw;
  }
  .icon{
    height: 70px;
    width: 70px;
  }
}
@media only screen and (max-width: 750px) {
  .enPosition {
    right: 17px !important;
  }
  .arPosition {
    left: 17px !important;
  }
}
@media only screen and (max-width: 570px) {
  .enPosition {
    right: 10px !important;
  }
  .arPosition {
    left: 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .FeedbackIcon{
    height: 40px;
    width: 40px;
  }
  .FeedbackIcon:hover{
    height: 50px;
    width: 50px;
  }
  .selected{
    height: 50px;
    width: 50px;
  }
  .iconContainer{
    padding: 2vh 2.5vw;
  }
  .icon{
    height: 55px;
  }
}
@media only screen and (max-width: 500px) {
  .FeedbackIcon{
    height: 30px;
    width: 30px;
  }
  .FeedbackIcon:hover{
    height: 40px;
    width: 40px;
  }
  .selected{
    height: 40px;
    width: 40px;
  }
  .iconContainer{
    padding: 2vh 1vw;
  }
  .icon{
    height: 50px;
    width: 50px;
  }
}
@media screen and (max-width: 1300px) {
  .feedbackForm{
    width: 1200px;
    margin-left: 2vw;
  }
  .yellow-button{
    right: 200px;
    bottom: 86px;
  }
}
@media screen and (max-width: 1160px) {
  .feedbackForm{
    width: 1060px;
  }
  .yellow-button{
    right: 170px;
    bottom: 78px;
  }
  .rowContainer{
    padding: 2px 5px;
  }
  .inputsContainer{
    width: 87%;
    height: 45%;
    /*background-color: #4caf50;*/
    bottom: 190px;
    position: absolute;
    left: 90px
  }
  .submitContainer{
    min-height: 35rem;
  }
}
@media screen and (max-width: 1050px) {
  .feedbackForm{
    width: 900px;
    display: none;
  }
  .feedbackForm2{
    display: block;
    width: 53rem;
    height: 35rem;
    margin-left: 2vw;
  }
  .inputsContainer{
    width: 80%;
    height: 53%;
  }
  .yellow-button{
    right: 157px;
    bottom: 75px;
    height: 85px;
    width: 85px;
  }
  .rowContainer {
    padding: 15px 5px;
  }
}
@media screen and (max-width: 770px) {
  .feedbackForm3{
   display: block;
    height: 40rem;
    width: 40rem;
    margin-left: 2vw;
  }
  .feedbackForm2{
    display: none;
  }
  .inputsContainer{
    width: 75%;
    height: 60%;
  }
  .yellow-button{
    right: 144px;
    height: 90px;
    width: 90px;
  }
  .rowContainer {
    padding: 30px 5px;
  }
  .inputsContainer{
    left: 80px;
  }
}
@media screen and (max-width: 570px) {
  .feedbackForm3{
    display: block;
    height: 35rem;
    width: 35rem;
  }
  .yellow-button{
    right: 125px;
    height: 85px;
    bottom: 65px;
    width: 85px;
  }
  .inputsContainer{
    left: 65px;
  }
}
@media screen and (max-width: 550px) {
  .feedbackForm3{
    height: 28rem;
    width: 28rem;
  }
  .rowContainer {
    padding: 8px 5px;
  }
  .yellow-button{
    right: 115px;
    bottom: 55px;
  }
  .inputsContainer{
    width: 75%;
    height: 45%;
    bottom: 194px;
    left: 47px
  }
  .yellow-button{
    right: 96px;
    bottom: 54px;
    width: 75px;
    height: 75px;
  }
  .inputField, .inputFielddesc{
    font-size: 12px;
  }
}
@media screen and (max-width: 400px) {
  .feedbackForm3{
    height: 24rem;
    width: 24rem;
  }
  .yellow-button{
    right: 82px;
    bottom: 45px;
    width: 65px;
    height: 65px
  }
  .inputField, .inputFielddesc{
    font-size: 10px;
  }
}
input[type="file"] {
  margin-left: -2px !important;

  &::-webkit-file-upload-button {
    display: none;
  }
  &::file-selector-button {
    display: none;
  }
  &::after{
    content: '';
  }

}
.fileinput{
  cursor: pointer;
  text-align: start;
  color: #1D1D1D;
  position: relative;
}
.deleteFile{
  position: absolute;
  height: 20px;
  width: 20px;
  bottom: 20px;
  z-index: 10000;
  cursor: pointer;
}
.arPosition{
  left: 30px;
}
.enPosition{
  right: 30px;
}
.arabicStyle {
  direction: rtl;
  //transform: rotateY(180deg);
}
.firstTitle{
  padding: 0 4vw;
}
/*@media screen and (max-width: 750px) {*/
/*  .feedbackForm{*/
/*    width: 650px;*/
/*  }*/
/*  .yellow-button{*/
/*    right: 98px;*/
/*    bottom: 45px;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 700px) {*/
/*  .feedbackForm{*/
/*    width: 600px;*/
/*  }*/
/*  .yellow-button{*/
/*    right: 93px;*/
/*    bottom: 48px;*/
/*    height: 55px;*/
/*    width: 55px;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 650px) {*/
/*  .feedbackForm{*/
/*    width: 550px;*/
/*  }*/
/*  .yellow-button{*/
/*    right: 83px;*/
/*    bottom: 40px;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 600px) {*/
/*  .feedbackForm{*/
/*    width: 500px;*/
/*  }*/
/*  .yellow-button{*/
/*    right: 78px;*/
/*    bottom: 35px;*/
/*    height: 45px;*/
/*    width: 45px;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 550px) {*/
/*  .feedbackForm{*/
/*    width: 450px;*/
/*  }*/
/*  .yellow-button{*/
/*    right: 68px;*/
/*    bottom: 33px;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 500px) {*/
/*  .feedbackForm{*/
/*    width: 400px;*/
/*  }*/
/*  .yellow-button{*/
/*    right: 63px;*/
/*    bottom: 30px;*/
/*    height: 35px;*/
/*    width: 35px;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 450px) {*/
/*  .feedbackForm{*/
/*    width: 350px;*/
/*  }*/
/*  .yellow-button{*/
/*    right: 156px;*/
/*    bottom: 75px;*/
/*  }*/
/*}*/
.hidden{
  display: none !important;
}
</style>
